export default {
  // Common
  common: {
    welcome: 'مرحباً',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    search: 'بحث...',
    filter: 'تصفية',
    export: 'تصدير',
    refresh: 'تحديث',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    confirm: 'تأكيد',
    yes: 'نعم',
    no: 'لا',
    close: 'إغلاق',
    actions: 'إجراءات',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'غير نشط',
    enabled: 'مفعل',
    disabled: 'معطل',
    success: 'نجح',
    error: 'خطأ',
    warning: 'تحذير',
    info: 'معلومات',
  },

  // Auth
  auth: {
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    signIn: 'دخول',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    loginError: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    sessionExpired: 'انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.',
  },

  // Navigation
  nav: {
    dashboard: 'لوحة التحكم',
    instruments: 'الأدوات المالية',
    clients: 'العملاء',
    accounts: 'الحسابات',
    trading: 'التداول',
    reports: 'التقارير',
    settings: 'الإعدادات',
  },

  // Dashboard
  dashboard: {
    title: 'لوحة التحكم',
    overview: 'نظرة عامة',
    stats: 'الإحصائيات',
    totalClients: 'إجمالي العملاء',
    totalAccounts: 'إجمالي الحسابات',
    openPositions: 'الصفقات المفتوحة',
    todayPnL: 'الربح/الخسارة اليوم',
    liveAccounts: 'حسابات حقيقية',
    demoAccounts: 'حسابات تجريبية',
    activeClients: 'عملاء نشطون',
    newClients: 'عملاء جدد',
    volumeChart: 'حجم التداول (7 أيام)',
    pnlTrend: 'اتجاه الربح/الخسارة (30 يوم)',
    recentActivity: 'النشاط الأخير',
    quickActions: 'إجراءات سريعة',
  },

  // Instruments
  instruments: {
    title: 'إدارة الأدوات المالية',
    library: 'مكتبة الأدوات',
    enabled: 'الأدوات المفعلة',
    feed: 'قائمة الأدوات',
    symbol: 'الرمز',
    category: 'الفئة',
    priceScale: 'مقياس السعر',
    leverage: 'الرافعة المالية',
    spread: 'الفارق السعري',
    commission: 'العمولة',
    enable: 'تفعيل',
    disable: 'تعطيل',
    bulkEnable: 'تفعيل متعدد',
    settings: 'الإعدادات',
    tradeMode: 'وضع التداول',
    executionType: 'نوع التنفيذ',
    
    // Categories
    forex: 'العملات',
    crypto: 'العملات الرقمية',
    stocks: 'الأسهم',
    indices: 'المؤشرات',
    commodities: 'السلع',
    
    // Settings tabs
    general: 'عام',
    leverageLots: 'الرافعة والعقود',
    spreads: 'الفروقات السعرية',
    commissions: 'العمولات',
    riskManagement: 'إدارة المخاطر',
    advanced: 'متقدم',
    
    // Settings fields
    maxLeverage: 'أقصى رافعة مالية',
    minLotSize: 'أصغر حجم عقد',
    maxLotSize: 'أكبر حجم عقد',
    lotStep: 'خطوة العقد',
    spreadType: 'نوع الفارق',
    spreadMarkup: 'زيادة الفارق',
    fixedSpread: 'فارق ثابت',
    commissionPerLot: 'عمولة للعقد',
    commissionType: 'نوع العمولة',
    stopLevel: 'مستوى الإيقاف',
    freezeLevel: 'مستوى التجميد',
    maxPositions: 'أقصى عدد صفقات',
    
    // Messages
    enableSuccess: 'تم تفعيل الأداة بنجاح',
    disableSuccess: 'تم تعطيل الأداة بنجاح',
    updateSuccess: 'تم تحديث الإعدادات بنجاح',
    bulkEnableSuccess: 'تم تفعيل الأدوات بنجاح',
  },

  // Clients
  clients: {
    title: 'العملاء',
    clientsList: 'قائمة العملاء',
    clientDetails: 'تفاصيل العميل',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    country: 'الدولة',
    kycStatus: 'حالة التحقق',
    accountCount: 'الحسابات',
    totalBalance: 'الرصيد الإجمالي',
    lastLogin: 'آخر دخول',
    createdAt: 'تاريخ التسجيل',
    verified: 'موثق',
    pending: 'قيد المراجعة',
    rejected: 'مرفوض',
  },

  // Accounts
  accounts: {
    title: 'الحسابات',
    accountsList: 'قائمة الحسابات',
    accountDetails: 'تفاصيل الحساب',
    accountNumber: 'رقم الحساب',
    accountType: 'نوع الحساب',
    balance: 'الرصيد',
    equity: 'حقوق الملكية',
    margin: 'الهامش',
    freeMargin: 'الهامش الحر',
    marginLevel: 'مستوى الهامش',
    leverage: 'الرافعة المالية',
    credit: 'إيداع',
    debit: 'سحب',
    adjustBalance: 'تعديل الرصيد',
    changeLeverage: 'تغيير الرافعة',
    live: 'حقيقي',
    demo: 'تجريبي',
  },

  // Trading
  trading: {
    title: 'التداول',
    positions: 'الصفقات',
    orders: 'الأوامر',
    history: 'السجل',
    symbol: 'الرمز',
    side: 'الاتجاه',
    volume: 'الحجم',
    openPrice: 'سعر الفتح',
    currentPrice: 'السعر الحالي',
    pnl: 'الربح/الخسارة',
    buy: 'شراء',
    sell: 'بيع',
    open: 'مفتوح',
    pending: 'معلق',
    closed: 'مغلق',
    closedAt: 'تاريخ الإغلاق',
    openedAt: 'تاريخ الفتح',
    price: 'السعر',
    totalTrades: 'إجمالي الصفقات',
    winningTrades: 'صفقات رابحة',
    losingTrades: 'صفقات خاسرة',
    totalPnL: 'إجمالي الربح/الخسارة',
    account: 'الحساب',
    status: 'الحالة',
    swap: 'السواب',
    commission: 'العمولة',
    ticket: 'رقم الصفقة',
    noPositions: 'لا توجد صفقات مفتوحة',
    noOrders: 'لا توجد أوامر معلقة',
    noHistory: 'لا يوجد سجل تداول',
  },

  // Reports
  reports: {
    title: 'التقارير',
    exposure: 'تقرير التعرض',
    profitability: 'ربحية العملاء',
    daily: 'التقرير اليومي',
    dateRange: 'الفترة الزمنية',
    totalExposure: 'إجمالي التعرض',
    netVolume: 'صافي الحجم',
    topWinners: 'الأكثر ربحاً',
    topLosers: 'الأكثر خسارة',
    buyVolume: 'حجم الشراء',
    sellVolume: 'حجم البيع',
    positionCount: 'عدد الصفقات',
    winRate: 'معدل الفوز',
    rank: 'الترتيب',
    client: 'العميل',
    noData: 'لا توجد بيانات متاحة',
    totalVolume: 'الحجم الإجمالي',
    commission: 'العمولة',
    activeAccounts: 'الحسابات النشطة',
    export: 'تصدير',
    download: 'تنزيل',
    positions: 'الصفقات',
    trades: 'التداولات',
    winning: 'رابحة',
    losing: 'خاسرة',
  },

  // Settings
  settings: {
    title: 'الإعدادات',
    brokerInfo: 'معلومات الوسيط',
    accountGroups: 'مجموعات الحسابات',
    brokerName: 'اسم الوسيط',
    domain: 'النطاق',
    primaryColor: 'اللون الأساسي',
    secondaryColor: 'اللون الثانوي',
    logo: 'الشعار',
    supportEmail: 'بريد الدعم',
    supportPhone: 'هاتف الدعم',
    generalInfo: 'معلومات عامة',
    branding: 'العلامة التجارية',
    addNewGroup: 'إضافة مجموعة جديدة',
    noGroupsFound: 'لا توجد مجموعات حسابات',
    default: 'افتراضي',
    maxLeverage: 'أقصى رافعة مالية',
    marginCall: 'نداء الهامش',
    stopOut: 'إيقاف الخسارة',
    commission: 'العمولة',
    maxLotSize: 'أقصى حجم عقد',
    execution: 'التنفيذ',
    hedgingAllowed: 'التحوط مسموح',
    scalpingAllowed: 'المضاربة السريعة مسموحة',
    eaTrading: 'تداول الروبوتات',
    nbpEnabled: 'حماية الرصيد السالب',
    saving: 'جاري الحفظ...',
    groupName: 'اسم المجموعة',
    description: 'الوصف',
    editGroup: 'تعديل المجموعة',
    deleteGroup: 'حذف المجموعة',
  },

  // Theme
  theme: {
    light: 'الوضع النهاري',
    dark: 'الوضع الليلي',
    toggle: 'تبديل المظهر',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    select: 'اختر اللغة',
  },

  // Errors
  errors: {
    general: 'حدث خطأ ما',
    networkError: 'خطأ في الشبكة. يرجى التحقق من اتصالك.',
    unauthorized: 'غير مصرح. يرجى تسجيل الدخول مرة أخرى.',
    forbidden: 'تم رفض الوصول.',
    notFound: 'المورد غير موجود.',
    serverError: 'خطأ في الخادم. يرجى المحاولة لاحقاً.',
  },

  // Success messages
  success: {
    saved: 'تم الحفظ بنجاح',
    updated: 'تم التحديث بنجاح',
    deleted: 'تم الحذف بنجاح',
    created: 'تم الإنشاء بنجاح',
  },
};
